import React, { useLayoutEffect, useMemo } from 'react';
import {
    Banner,
    Content,
    LeftSide,
    List,
    ListWrapper,
    RightSide,
    ScrollOffset,
    WelcomInfo,
    Wrapper,
} from './auth-page.styled';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTE_LOGIN, ROUTE_REGISTER, ROUTE_BLOCKED, ROUTE_NOT_VERIFIED } from '@shared/config/routes/routes';
import { FormLoginUser } from '@features/current-user/login/ui/form-login-user';
import { FormRegisterUser } from '@features/user/register/ui/form-register-user';
import { useResetCache } from '../lib/hooks/use-reset-cache/use-reset-cache';
import { Footer } from '@shared/ui/footer/footer';
import { BlockedUserPage } from '@pages/blocked-user-page/blocked-user-page';
import { NotVerifiedUserPage } from '@pages/not-verified-user-page/not-verified-user-page';
import { useFilesListNoAuthSharedQuery } from '@entities/file/libs/hooks/use-files-list-no-auth-shared-query/use-files-list-no-auth-shared-query';
import { DOCUMENTS_LIST } from '@entities/file/config/documents-constants';
import { getFileUrlByCode } from '@entities/file/libs/hooks/use-files-list-no-auth-shared-query/get-file-url-by-code';
import { Typography } from '@shared/ui/typography/typography';
import { DEFAULT_FILES_LIST_PARAMS } from './constants';
import { AUTH_PRODUCT_LIST } from '../config/ui-constants';

export const AuthPage: React.FC = () => {
    useResetCache();

    const [getFilesNoAuthList, getFilesNoAuthListResult] = useFilesListNoAuthSharedQuery(DEFAULT_FILES_LIST_PARAMS);
    const filesData = getFilesNoAuthListResult.data?.items || [];

    useLayoutEffect(() => {
        getFilesNoAuthList(DEFAULT_FILES_LIST_PARAMS);
    }, []);

    const filesList: Partial<Record<DOCUMENTS_LIST, string>> = useMemo(() => {
        const codes = DEFAULT_FILES_LIST_PARAMS?.codes?.split(',') || [];

        return Object.fromEntries(codes?.map((code) => [code, getFileUrlByCode(filesData, code as DOCUMENTS_LIST)]));
    }, [filesData]);

    return (
        <Wrapper>
            <Content>
                <LeftSide>
                    <Banner src={filesList[DOCUMENTS_LIST.WELCOM_BANNER]} />
                    <WelcomInfo>
                        <Typography size='subtitle1'>
                            <b>Личный кабинет НОТА</b> – это единая регистрация для получения специальных предложений по
                            продуктам и сервисам НОТА.
                        </Typography>
                        <Typography size='subtitle1'>
                            Через личный кабинет вы можете запросить демо по следующим продуктам:
                        </Typography>
                        <ListWrapper>
                            <List>
                                {AUTH_PRODUCT_LIST.slice(0, 3).map((productText, idx) => (
                                    <li key={`${idx}_${productText}`}>
                                        <Typography size='subtitle2'>{productText}</Typography>
                                    </li>
                                ))}
                            </List>
                            <List>
                                {AUTH_PRODUCT_LIST.slice(3).map((productText, idx) => (
                                    <li key={`${idx}_${productText}`}>
                                        <Typography size='subtitle2'>{productText}</Typography>
                                    </li>
                                ))}
                            </List>
                        </ListWrapper>
                        <Typography size='subtitle1'>а также приобрести лицензии на продукты DION и Юнион.</Typography>
                    </WelcomInfo>
                </LeftSide>
                <RightSide>
                    <ScrollOffset>
                        <Switch>
                            <Route path={ROUTE_LOGIN} component={FormLoginUser} exact />
                            <Route path={ROUTE_REGISTER} component={FormRegisterUser} exact />
                            <Route path={ROUTE_BLOCKED} component={BlockedUserPage} exact />
                            <Route path={ROUTE_NOT_VERIFIED} component={NotVerifiedUserPage} exact />
                            <Redirect to={ROUTE_LOGIN} />
                        </Switch>
                    </ScrollOffset>
                </RightSide>
            </Content>
            <Footer />
        </Wrapper>
    );
};
